import { filter, map, mergeMap, take } from 'rxjs/operators';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ModalCloseAction } from '../store/modal.action';
import { AppState, ModalCategory } from '../store/modal.state';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { SurveyService } from '../../../entities/survey/provider/survey.service';
import { AuthPermissionService } from '../../auth/auth-permission.service';
import { PatientusRole } from '../../auth/auth.roles';
import { ProfileService } from '../../profile/providers/profile.service';
import { Survey } from '../../../entities/survey/model/survey.model';
import { ConnectionListenerService } from '../../../entities/webrtc-connection-stats';

@Component({
    selector: 'app-survey-overlay',
    templateUrl: './survey-overlay.component.html',
    styleUrls: ['./survey-overlay.component.scss']
})
export class SurveyOverlayComponent implements OnInit, OnDestroy {

    surveySelected = true;
    surveyLink: string;
    public showSurvey = false;

    private surveyOverlaySubscription: Subscription = null;
    private surveyLinkSubscription: Subscription = null;

    constructor(
        private store: Store<AppState>,
        private survey: SurveyService,
        private permissionService: AuthPermissionService,
        private profileService: ProfileService,
        protected connectionListener: ConnectionListenerService,
    ) {
    }

    ngOnInit() {
        this.surveyOverlaySubscription = this.store.select(s => s.modal).subscribe(modalStore => {
                this.showSurvey = (modalStore.isActive && (modalStore.category === ModalCategory.SURVEY_POPUP));

                // NOTE: this is part of a dirty hack to fix an iOS scrolling issue with the zoho-survey iframe.
                if (this.showSurvey === true) {
                    setTimeout(function() {
                        const dashboardWrapper =  document.getElementById('dashboard-wrapper');
                        if (dashboardWrapper) {
                            dashboardWrapper.setAttribute('style', 'position: fixed; width: 100%;');
                        } else {
                            document.getElementById('simpleLayout')
                                .setAttribute('style', 'position: fixed; width: 100%;');
                        }
                    }, 500);
                } else if (
                    !this.showSurvey &&
                    (document.getElementById('dashboard-wrapper') || document.getElementById('simpleLayout'))
                ) {
                    const dashboardWrapper =  document.getElementById('dashboard-wrapper');
                    if (dashboardWrapper) {
                        dashboardWrapper.removeAttribute('style');
                    } else {
                        document.getElementById('simpleLayout').removeAttribute('style');
                    }
                }
            }
        );

        this.surveyLinkSubscription = this.permissionService.getCurrentRole().pipe(
            filter(role => role === PatientusRole.DOCTOR || role === PatientusRole.PATIENT),
            mergeMap(role => this.getSurvey(role)),
            map(({surveyLink}) => this.surveyLink = surveyLink),
            mergeMap(link => this.addProfileDataToLink(link)),
            mergeMap(link => this.addAppointmentIdToLink(link)))
            .subscribe((link) => {
                this.surveyLink = link;
            });
    }

    private getSurvey(isDoctor: PatientusRole): Observable<Survey> {
        if (isDoctor === PatientusRole.DOCTOR) {
            return this.survey.getDoctorSurvey();
        } else {
            return this.survey.getPatientSurvey();
        }
    }

    private addAppointmentIdToLink(link: string): Observable<any> {
        return this.connectionListener
            .getData().pipe(
                map(conferenceData => link + '&aid=' + conferenceData.appointmentId));
    }

    private addProfileDataToLink(link: string): Observable<string> {
        return this.profileService
            .getCurrentProfileDataObserver().pipe(
                take(1),
                map(profile => {
                    link = link + '?id=' + profile.id;
                    if (profile.email) {
                        link = link + '&email=' + profile.email;
                    }
                    return link;
                }));
    }

    startSurvey() {
        this.surveySelected = true;
    }

    closeSurvey() {
        // NOTE: this is part of a dirty hack to fix an iOS scrolling issue with the zoho-survey iframe.
        const dashboardWrapper =  document.getElementById('dashboard-wrapper');
        if (dashboardWrapper) {
            dashboardWrapper.removeAttribute('style');
        } else {
            document.getElementById('simpleLayout').removeAttribute('style');
        }
        this.showSurvey = false;
        this.surveySelected = true;
        this.store.dispatch(new ModalCloseAction());
    }

    ngOnDestroy(): void {
        if (this.surveyOverlaySubscription !== null) {
            this.surveyOverlaySubscription.unsubscribe();
        }

        if (this.surveyLinkSubscription !== null) {
            this.surveyLinkSubscription.unsubscribe();
        }
    }
}
